import alertTriangleIcon from "@tabler/icons/outline/alert-triangle.svg";
import React from "react";
import { useIntl } from "react-intl";

import { Blankslate, Stack } from "./ui";

const MissingIndicator = () => {
  const intl = useIntl();

  return (
    <Stack
      justifyContent="center"
      className="h-full"
      data-testid="missing-indicator"
    >
      <Blankslate
        iconSrc={alertTriangleIcon}
        title={intl.formatMessage({
          id: "missing_indicator.label",
          defaultMessage: "Not found",
        })}
        subtitle={intl.formatMessage({
          id: "missing_indicator.sublabel",
          defaultMessage: "This resource could not be found",
        })}
        linkText={intl.formatMessage({
          id: "missing_indicator.link",
          defaultMessage: "Go back",
        })}
        linkSrc={document.referrer || "/"}
      />
    </Stack>
  );
};

export default MissingIndicator;
